import { Card, CardContent, Box, Typography } from '@mui/material'
import { KitStatusLabels, labTestSampleGradeChoices } from '../../../utils/constants'
import { getResultTier, TIER_COLORS } from './resultTiers'

const ResultHero = ({ record }) => {
  const restrictedStatus = ['pendingConfirmation', 'manualReview'].includes(record?.status)
  const result = record?.labTestResult
  const { tier, label, icon } = getResultTier(result)
  const color = TIER_COLORS[tier]

  const statusLabel = restrictedStatus ? KitStatusLabels[record.status] : label
  const statusMessage = restrictedStatus
    ? record?.status === 'manualReview'
      ? 'Results are temporarily unavailable while this kit is under manual review.'
      : 'Results are temporarily unavailable while this kit is pending confirmation.'
    : ''

  // Unrecognized values fall through to the neutral default tier above and
  // must never be implied as "cleared" — surface the raw value verbatim.
  const isUnknown = result && !['NSS', 'Positive', 'error', 'none'].includes(result)

  const gradeChoice = labTestSampleGradeChoices.find((g) => g.value === record?.labTestSampleGrade)

  return (
    <Card sx={{ borderLeft: `6px solid ${restrictedStatus ? TIER_COLORS.warning : color}` }}>
      <CardContent sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 48,
            height: 48,
            borderRadius: '50%',
            backgroundColor: `${restrictedStatus ? TIER_COLORS.warning : color}22`,
            color: restrictedStatus ? TIER_COLORS.warning : color,
            flexShrink: 0,
          }}
          aria-hidden="true"
        >
          <span className={`fa-solid fa-${restrictedStatus ? 'triangle-exclamation' : icon} fa-lg`}></span>
        </Box>
        <Box>
          <Typography variant="h5" fontWeight="bold" sx={{ color: restrictedStatus ? TIER_COLORS.warning : color }}>
            {statusLabel}
            {!restrictedStatus && isUnknown && ` (${result})`}
          </Typography>
          {restrictedStatus ? (
            <Typography variant="body1" sx={{ mt: 0.5 }}>
              {statusMessage}
            </Typography>
          ) : result === 'Positive' && gradeChoice ? (
            <Typography variant="body1" sx={{ mt: 0.5 }}>
              Grade: {gradeChoice.label}
            </Typography>
          ) : null}
          {['manualReview', 'error'].includes(record?.status) && Array.isArray(record?.statusTags) && record.statusTags.length > 0 && (
            <Box sx={{ mt: 1, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {record.statusTags.map((tag, index) => (
                <Box
                  key={`${tag}-${index}`}
                  component="span"
                  sx={{
                    display: 'inline-block',
                    px: 1,
                    py: 0.5,
                    borderRadius: 999,
                    backgroundColor: '#f3f3f3',
                    fontSize: '0.85rem',
                    fontWeight: 500,
                    lineHeight: 1.4,
                  }}
                >
                  {tag}
                </Box>
              ))}
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  )
}

export default ResultHero
